<template>
  <div class="AgreementProfile">

    <h1 class="m-label" style="margin: 0">
      契約基本情報
    </h1>

    <template v-if="agreement.id == edit_id.agreement_id">
      <form @submit.prevent="patchAgreement(agreement)">
        <div class="m-box__inner">
          <table class="m-detail">
            <template v-if="!valid">
              <tr>
                <th>エラー</th>
                <td class="errors"><div>{{errors}}が入力されていません</div></td>
              </tr>
            </template>
            <tr>
              <th>給与計算</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.payroll_check" placeholder="給与計算チェック" @keypress.self.prevent.13></td>
              <th></th>
              <td></td>
            </tr>
            <tr>
              <th>ID</th>
              <td>{{agreement.id}}</td>
              <th>生徒ID</th>
              <td>{{agreement.student_id}}</td>
            </tr>
            <tr>
              <th>契約者名</th>
              <td><input type='text' class="name_w" v-model="agreement.f_name" placeholder="姓" @keypress.self.prevent.13><input type='text' class="name_w" v-model="agreement.l_name" placeholder="名" @keypress.self.prevent.13></td>
              <th>契約者名(かな)</th>
              <td><input type='text' class="name_w" v-model="agreement.f_name_kana" placeholder="せい" @keypress.self.prevent.13><input type='text' class="name_w" v-model="agreement.l_name_kana" placeholder="めい" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>住所</th>
              <td><input type='text' v-model="agreement.address" placeholder="住所" @keypress.self.prevent.13></td>
              <th>住所2</th>
              <td><input type='text' v-model="agreement.address2" placeholder="住所2" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">携帯TEL</th>
              <td><input type='text' required maxlength="11" minlength="10" v-model="agreement.tel" placeholder="携帯TEL" @keypress.self.prevent.13></td>
              <th>固定TEL</th>
              <td><input type='text' maxlength="11" minlength="10" v-model="agreement.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">契約種類</th>
              <td><multiselect required v-model="watch.contract_type" :options="contract_type" label="name" :searchable="false" :show-labels="false" placeholder="契約種類"></multiselect></td>
              <th>契約日付</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.contract_date" placeholder="契約日付" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>担当者</th>
              <td><input type='text' v-model="agreement.person" placeholder="担当者" @keypress.self.prevent.13></td>
              <th>内容変更日付</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.change_date" placeholder="内容変更日付" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>解約種類</th>
              <td><multiselect v-model="watch.cancel_type" :options="cancel_type" label="name" :searchable="false" :show-labels="false" placeholder="解約種類"></multiselect></td>
              <th>解約日付</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.cancel_date" placeholder="キャンセル日付" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>商品名</th>
              <td colspan="3"><input type='text' v-model="agreement.product_name" placeholder="商品名" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>合計ポイント</th>
              <td><input type='number' step='0.05' maxlength='5' v-model="agreement.point_total" placeholder="合計ポイント" @keypress.self.prevent.13></td>
              <th class="req">支払方法種別</th>
              <td><multiselect v-model="watch.payment_type" :options="payment_type" label="name" :searchable="false" :show-labels="false" placeholder="支払方法種別"></multiselect></td>
            </tr>
            <tr>
              <th class="req">テキスト種類</th>
              <td><multiselect v-model="watch.text_type" :options="text_type" label="name" :searchable="false" :show-labels="false" placeholder="テキスト種類"></multiselect></td>
              <th>定価</th>
              <td><input type='text' v-model="agreement.amount" placeholder="定価" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>値引</th>
              <td><input type='text' v-model="agreement.discount" placeholder="値引" @keypress.self.prevent.13></td>
              <th>販売価格</th>
              <td><input disabled type='text' :value="pure_amount" placeholder="販売価格" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>分割手数料</th>
              <td><input type='text' v-model="agreement.division_commission" placeholder="分割手数料" @keypress.self.prevent.13></td>
              <th>お支払総額</th>
              <td><input disabled type='text' :value="total_amount" placeholder="お支払総額" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">支払回数</th>
              <td><multiselect v-model="watch.payments_number" :options="payments_number" label="name" :searchable="true" :show-labels="false" placeholder="支払回数"></multiselect></td>
              <th>テキスト代入金日</th>
              <td><input type='text' maxlength="10" minlength="10" v-model="agreement.deposit_amount_date" placeholder="テキスト代入金日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>支払期間/開始(テキスト)</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.text_payment_period_start" placeholder="支払期間/開始(テキスト)" @keypress.self.prevent.13></td>
              <th>支払期間/終了(テキスト)</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.text_payment_period_end" placeholder="支払期間/終了(テキスト)" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">役務期間/開始</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="agreement.service_period_start" placeholder="役務期間/開始" @keypress.self.prevent.13></td>
              <th class="req">役務期間/終了</th>
              <td><input type="text" required maxlength="10" minlength="10" v-model="agreement.service_period_end" placeholder="役務期間/終了" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>初月管理費支払方法</th>
              <td><multiselect v-model="watch.first_month_deposit_method" :options="method" label="name" :searchable="false" :show-labels="false" placeholder="初月管理費支払方法"></multiselect></td>
              <th>初月管理費チェック</th>
              <td><input type='text' v-model="agreement.first_month_deposit_check" placeholder="初月管理費チェック" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th class="req">入会金</th>
              <td><input type='text' required v-model="agreement.admission_fee" placeholder="入会金" @keypress.self.prevent.13></td>
              <th>入会金支払方法</th>
              <td><multiselect v-model="watch.admission_fee_method" :options="method" label="name" :searchable="false" :show-labels="false" placeholder="入会金支払方法"></multiselect></td>
            </tr>
            <tr>
              <th>入会金チェック</th>
              <td colspan="3"><input type='text' v-model="agreement.admission_fee_check" placeholder="入会金チェック" @keypress.self.prevent.13 @focus="focusAdmission_fee_check"></td>
            </tr>
            <tr>
              <th class="req">保証金</th>
              <td><input type='text' required v-model="agreement.deposit" placeholder="保証金" @keypress.self.prevent.13></td>
              <th>保証金支払方法</th>
              <td><multiselect v-model="watch.deposit_method" :options="method" label="name" :searchable="false" :show-labels="false" placeholder="保証金支払方法"></multiselect></td>
            </tr>
            <tr>
              <th>保証金チェック</th>
              <td><input type='text' v-model="agreement.deposit_check" placeholder="保証金チェック" @keypress.self.prevent.13 @focus="focusDeposit_check"></td>
              <th>銀行番号</th>
              <td><input type='text' v-model="agreement.bank_number" placeholder="銀行番号" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>支店番号</th>
              <td><input type='text' v-model="agreement.branch_number" placeholder="支店番号" @keypress.self.prevent.13></td>
              <th>預金種目</th>
              <td><multiselect v-model="watch.deposit_item" :options="deposit_item" label="name" :searchable="false" :show-labels="false" placeholder="預金種目"></multiselect></td>
            </tr>
            <tr>
              <th>口座番号</th>
              <td><input type='text' v-model="agreement.account_number" placeholder="口座番号" @keypress.self.prevent.13></td>
              <th>口座名義</th>
              <td><input type='text' v-model="agreement.account_holder" placeholder="口座名義" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>保証金返金予定日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.expected_refund_date" placeholder="保証金返金予定日" @keypress.self.prevent.13></td>
              <th>保証金返金日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.deposit_refund_date" placeholder="保証金返金日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>承認No.</th>
              <td><input type='text' maxlength='13' v-model="agreement.approval_number" placeholder="承認No." @keypress.self.prevent.13></td>
              <th>承認日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.approval_date" placeholder="承認日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>学年</th>
              <td><input type='text' v-model="agreement.grade" placeholder="学年" @keypress.self.prevent.13></td>
              <th>納品日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.delivery_date" placeholder="納品日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>契約書回収日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.contract_collection_date" placeholder="契約書回収日" @keypress.self.prevent.13></td>
              <th>ファクター回収日</th>
              <td><input type="text" maxlength="10" minlength="10" v-model="agreement.factor_collection_date" placeholder="ファクター回収日" @keypress.self.prevent.13></td>
            </tr>
            <tr>
              <th>ファクターチェック</th>
              <td><multiselect v-model="watch.factor_check" :options="factor_check" label="name" :searchable="false" :show-labels="false" placeholder="ファクターチェック"></multiselect></td>
              <th>経理台帳入力</th>
              <td><multiselect v-model="watch.ledger_check" :options="ledger_check" label="name" :searchable="false" :show-labels="false" placeholder="経理台帳入力"></multiselect></td>
            </tr>
            <tr>
              <th>CXLチェック</th>
              <td><multiselect v-model="watch.cancel_check" :options="cancel_check" label="name" :searchable="false" :show-labels="false" placeholder="CXLチェック"></multiselect></td>
              <th>内容変更チェック</th>
              <td><multiselect v-model="watch.change_check" :options="change_check" label="name" :searchable="false" :show-labels="false" placeholder="内容変更チェック"></multiselect></td>
            </tr>
            <tr>
              <th>備考</th>
              <td colspan="3"><textarea type="text" v-model="agreement.note" placeholder="備考"></textarea></td>
            </tr>
          </table>
        </div>
        <div style="display: flex">
          <btn class="m-btn m-btn--default"><i class="fa fa-pencil-square-o"></i>更新</btn>
          <btn class="m-btn m-btn--default cancel" type="button" @click.native.prevent="cancelAgreement(agreement)"><i class="fa fa-pencil-square-o"></i>キャンセル</btn>
        </div>
      </form>
    </template>

    <template v-if="agreement.id !== edit_id.agreement_id">
      <div class="m-box__inner">
        <table class="m-detail">
          <template v-if="!valid">
            <!-- <tr> -->
            <!--   <th>エラー</th> -->
            <!--   <td class="errors"><div>{{errors}}が入力されていません</div></td> -->
            <!-- </tr> -->
          </template>
          <tr>
            <th>給与計算</th>
            <td>{{agreement.payroll_check}}</td>
            <th></th>
            <td></td>
          </tr>
          <tr>
            <th>ID</th>
            <td>{{agreement.id}}</td>
            <th>生徒ID</th>
            <td>{{agreement.student_id}}</td>
          </tr>
          <tr>
            <th>契約者名</th>
            <td>{{agreement.f_name}} {{agreement.l_name}}</td>
            <th>契約者名(かな)</th>
            <td>{{agreement.f_name_kana}} {{agreement.l_name_kana}}</td>
          </tr>
          <tr>
            <th>住所</th>
            <td>{{agreement.address}}</td>
            <th>住所2</th>
            <td>{{agreement.address2}}</td>
          </tr>
          <tr>
            <th>携帯TEL</th>
            <td>{{agreement.tel}}</td>
            <th>固定TEL</th>
            <td>{{agreement.tel2}}</td>
          </tr>
          <tr>
            <th>契約種類</th>
            <td>{{agreement.contract_type}}</td>
            <th>契約日付</th>
            <td>{{agreement.contract_date}}</td>
          </tr>
          <tr>
            <th>担当者</th>
            <td>{{agreement.person}}</td>
            <th>内容変更日付</th>
            <td>{{agreement.change_date}}</td>
          </tr>
          <tr>
            <th>解約種類</th>
            <td>{{agreement.cancel_type}}</td>
            <th>解約日付</th>
            <td>{{agreement.cancel_date}}</td>
          </tr>
          <tr>
            <th>商品名</th>
            <td colspan="3">{{agreement.product_name}}</td>
          </tr>
          <tr>
            <th>合計ポイント</th>
            <td>{{agreement.point_total}}</td>
            <th>支払方法種別</th>
            <td>{{agreement.payment_type}}</td>
          </tr>
          <tr>
            <th>テキスト種類</th>
            <td>{{agreement.text_type}}</td>
            <th>定価</th>
            <td>{{agreement.amount}}</td>
          </tr>
          <tr>
            <th>値引</th>
            <td>{{agreement.discount}}</td>
            <th>販売価格</th>
            <td>{{agreement.pure_amount}}</td>
          </tr>
          <tr>
            <th>分割手数料</th>
            <td>{{agreement.division_commission}}</td>
            <th>お支払総額</th>
            <td>{{agreement.total_amount}}</td>
          </tr>
          <tr>
            <th>支払回数</th>
            <td>{{agreement.payments_number}}</td>
            <th>テキスト代入金日</th>
            <td>{{agreement.deposit_amount_date}}</td>
          </tr>
          <tr>
            <th>支払期間/開始(テキスト)</th>
            <td>{{agreement.text_payment_period_start}}</td>
            <th>支払期間/終了(テキスト)</th>
            <td>{{agreement.text_payment_period_end}}</td>
          </tr>
          <tr>
            <th>役務期間/開始</th>
            <td>{{agreement.service_period_start}}</td>
            <th>役務期間/終了</th>
            <td>{{agreement.service_period_end}}</td>
          </tr>
          <tr>
            <th>初月管理費支払方法</th>
            <td>
              <template v-if="agreement.first_month_deposit_method === 0"></template>
              <template v-if="agreement.first_month_deposit_method === 1">振込</template>
              <template v-if="agreement.first_month_deposit_method === 2">現金</template>
              <template v-if="agreement.first_month_deposit_method === 3">Coiney</template>
            </td>
            <th>初月管理費チェック</th>
            <td>{{agreement.first_month_deposit_check}}</td>
          </tr>
          <tr>
            <th>入会金</th>
            <td>{{agreement.admission_fee}}</td>
            <th>入会金支払方法</th>
            <td>
              <template v-if="agreement.admission_fee_method === 0"></template>
              <template v-if="agreement.admission_fee_method === 1">振込</template>
              <template v-if="agreement.admission_fee_method === 2">現金</template>
              <template v-if="agreement.admission_fee_method === 3">Coiney</template>
            </td>
          </tr>
          <tr>
            <th>入会金チェック</th>
            <td colspan="3">{{agreement.admission_fee_check}}</td>
          </tr>
          <tr>
            <th>保証金</th>
            <td>{{agreement.deposit}}</td>
            <th>保証金支払方法</th>
            <td>
              <template v-if="agreement.deposit_method === 0"></template>
              <template v-if="agreement.deposit_method === 1">振込</template>
              <template v-if="agreement.deposit_method === 2">現金</template>
              <template v-if="agreement.deposit_method === 3">Coiney</template>
            </td>
          </tr>
          <tr>
            <th>保証金チェック</th>
            <td>{{agreement.deposit_check}}</td>
            <th>銀行番号</th>
            <td>{{agreement.bank_number}}</td>
          </tr>
          <tr>
            <th>支店番号</th>
            <td>{{agreement.branch_number}}</td>
            <th>預金種目</th>
            <td>
              <template v-if="agreement.deposit_item === 0"></template>
              <template v-if="agreement.deposit_item === 1">普通</template>
              <template v-if="agreement.deposit_item === 2">当座</template>
            </td>
          </tr>
          <tr>
            <th>口座番号</th>
            <td>{{agreement.account_number}}</td>
            <th>口座名義</th>
            <td>{{agreement.account_holder}}</td>
          </tr>
          <tr>
            <th>保証金返金予定日</th>
            <td>{{agreement.expected_refund_date}}</td>
            <th>保証金返金日</th>
            <td>{{agreement.deposit_refund_date}}</td>
          </tr>
          <tr>
            <th>承認No.</th>
            <td>{{agreement.approval_number}}</td>
            <th>承認日</th>
            <td>{{agreement.approval_date}}</td>
          </tr>
          <tr>
            <th>学年</th>
            <td>{{agreement.grade}}</td>
            <th>納品日</th>
            <td>{{agreement.delivery_date}}</td>
          </tr>
          <tr>
            <th>契約書回収日</th>
            <td>{{agreement.contract_collection_date}}</td>
            <th>ファクター回収日</th>
            <td>{{agreement.factor_collection_date}}</td>
          </tr>
          <tr>
            <th>ファクターチェック</th>
            <td>
              <template v-if="agreement.factor_check === 0">未選択</template>
              <template v-if="agreement.factor_check === 1">済</template>
              <template v-if="agreement.factor_check === 2">未</template>
              <template v-if="agreement.factor_check === 3">無</template>
            </td>
            <th>経理台帳入力</th>
            <td>
              <template v-if="agreement.ledger_check === 0">未選択</template>
              <template v-if="agreement.ledger_check === 1">済</template>
              <template v-if="agreement.ledger_check === 2">未</template>
              <template v-if="agreement.ledger_check === 3">無</template>
            </td>
          </tr>
          <tr>
            <th>CXLチェック</th>
            <td>
              <template v-if="agreement.cancel_check === 0">未選択</template>
              <template v-if="agreement.cancel_check === 1">済</template>
              <template v-if="agreement.cancel_check === 2">未</template>
              <template v-if="agreement.cancel_check === 3">無</template>
            </td>
            <th>内容変更チェック</th>
            <td>
              <template v-if="agreement.change_check === 0">未選択</template>
              <template v-if="agreement.change_check === 1">済</template>
              <template v-if="agreement.change_check === 2">未</template>
              <template v-if="agreement.change_check === 3">無</template>
            </td>
          </tr>
          <tr>
            <th>備考</th>
            <td colspan="3">{{agreement.note}}</td>
          </tr>
        </table>
      </div>
      <btn @click.native="edit(agreement)"><i class="fa fa-pencil-square-o"></i>編集</btn>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    agreement: Object,
    edit_id: Object
  },
  data () {
    return {
      watch: {
        contract_type: '',
        cancel_type: '',
        payment_type: '',
        text_type: '',
        payments_number: '',
        first_month_deposit_method: '',
        admission_fee_method: '',
        deposit_method: '',
        deposit_item: '',
        factor_check: '',
        ledger_check: '',
        cancel_check: '',
        change_check: ''
      }
    }
  },

  computed: {
    user () {
      return this.$store.getters.user
    },

    pure_amount () {
      const pure_amount = Number(this.agreement.amount) - Number(this.agreement.discount)
      this.agreement.pure_amount = pure_amount
      return pure_amount
    },

    total_amount () {
      const total_amount = this.pure_amount + Number(this.agreement.division_commission)
      this.agreement.total_amount = total_amount
      return total_amount
    },

    contract_type () {
      return this.$store.getters['agreements/contract_type']
    },

    cancel_type () {
      return this.$store.getters['agreements/cancel_type']
    },

    payment_type () {
      return this.$store.getters['agreements/payment_type']
    },

    text_type () {
      return this.$store.getters['agreements/text_type']
    },

    payments_number () {
      return this.$store.getters['agreements/payments_number']
    },

    method () {
      return this.$store.getters['agreements/method']
    },

    deposit_item () {
      return this.$store.getters['agreements/deposit_item']
    },

    factor_check () {
      return this.$store.getters['agreements/factor_check']
    },

    ledger_check () {
      return this.$store.getters['agreements/ledger_check']
    },

    cancel_check () {
      return this.$store.getters['agreements/cancel_check']
    },

    change_check () {
      return this.$store.getters['agreements/change_check']
    },

    advisors () {
      return this.$store.getters.advisors
    },

    // validation
    telErrors () {
      return this.agreement.tel ? [] : ['携帯TEL']
    },

    contract_typeErrors () {
      return this.agreement.contract_type ? [] : ['契約種類']
    },

    payment_typeErrors () {
      return this.agreement.payment_type ? [] : ['支払方法種別']
    },

    text_typeErrors () {
      return this.agreement.text_type ? [] : ['テキスト種類']
    },

    payments_numberErrors () {
      return this.agreement.payments_number ? [] : ['支払回数']
    },

    admission_feeErrors () {
      return this.agreement.admission_fee ? [] : ['入会金']
    },

    depositErrors () {
      return this.agreement.deposit ? [] : ['保証金']
    },

    errors () {
      let errors = [].concat(
        this.telErrors,
        this.contract_typeErrors,
        this.payment_typeErrors,
        this.text_typeErrors,
        this.payments_numberErrors,
        this.admission_feeErrors,
        this.depositErrors
      )
      let errorsJoin = errors.join('・')
      return errorsJoin
    },

    valid: function () {
      return !this.errors
    }
  },
  watch: {
    'watch.contract_type': function (now, old) {
      if (now) {
        this.agreement.contract_type = now.value
      } else {
        this.agreement.contract_type = ''
      }
    },

    'watch.cancel_type': function (now, old) {
      if (now) {
        this.agreement.cancel_type = now.value
      } else {
        this.agreement.cancel_type = ''
      }
    },

    'watch.payment_type': function (now, old) {
      if (now) {
        this.agreement.payment_type = now.value
      } else {
        this.agreement.payment_type = ''
      }
    },

    'watch.text_type': function (now, old) {
      if (now) {
        this.agreement.text_type = now.value
      } else {
        this.agreement.text_type = ''
      }
    },

    'watch.payments_number': function (now, old) {
      if (now) {
        this.agreement.payments_number = now.value
      } else {
        this.agreement.payments_number = ''
      }
    },

    'watch.first_month_deposit_method': function (now, old) {
      if (now) {
        this.agreement.first_month_deposit_method = now.value
      } else {
        this.agreement.first_month_deposit_method = ''
      }
    },

    'watch.admission_fee_method': function (now, old) {
      if (now) {
        this.agreement.admission_fee_method = now.value
      } else {
        this.agreement.admission_fee_method = ''
      }
    },

    'watch.deposit_method': function (now, old) {
      if (now) {
        this.agreement.deposit_method = now.value
      } else {
        this.agreement.deposit_method = ''
      }
    },

    'watch.deposit_item': function (now, old) {
      if (now) {
        this.agreement.deposit_item = now.value
      } else {
        this.agreement.deposit_item = ''
      }
    },

    'watch.factor_check': function (now, old) {
      if (now) {
        this.agreement.factor_check = now.value
      } else {
        this.agreement.factor_check = ''
      }
    },

    'watch.ledger_check': function (now, old) {
      if (now) {
        this.agreement.ledger_check = now.value
      } else {
        this.agreement.ledger_check = ''
      }
    },

    'watch.cancel_check': function (now, old) {
      if (now) {
        this.agreement.cancel_check = now.value
      } else {
        this.agreement.cancel_check = ''
      }
    },

    'watch.change_check': function (now, old) {
      if (now) {
        this.agreement.change_check = now.value
      } else {
        this.agreement.change_check = ''
      }
    }
  },
  methods: {
    edit (agreement) {
      // console.log(agreement)
      this.watch.contract_type = { name: agreement.contract_type, value: agreement.contract_type }
      this.watch.cancel_type = { name: agreement.cancel_type, value: agreement.cancel_type }
      this.watch.payment_type = { name: agreement.payment_type, value: agreement.payment_type }
      this.watch.text_type = { name: agreement.text_type, value: agreement.text_type }
      this.watch.payments_number = { name: agreement.payments_number, value: agreement.payments_number }
      this.watch.first_month_deposit_method = this.method[agreement.first_month_deposit_method]
      this.watch.admission_fee_method = this.method[agreement.admission_fee_method]
      this.watch.deposit_method = this.method[agreement.deposit_method]
      this.watch.deposit_item = this.deposit_item[agreement.deposit_item]
      this.watch.factor_check = this.factor_check[agreement.factor_check]
      this.watch.ledger_check = this.ledger_check[agreement.ledger_check]
      this.watch.cancel_check = this.cancel_check[agreement.cancel_check]
      this.watch.change_check = this.change_check[agreement.change_check]
      this.edit_id.agreement_id = agreement.id
    },

    cancelAgreement (list) {
      this.$store.dispatch('cancelAgreement', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchAgreement (list) {
      this.$store.dispatch('patchAgreement', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    focusAdmission_fee_check () {
      if (this.user.type === 'staff' && this.agreement.admission_fee_method === 2) {
        alert('支払方法が現金です、MGRに確認してください。')
        document.activeElement.blur()
      } else {
        return
      }
    },

    focusDeposit_check () {
      if (this.user.type === 'staff' && this.agreement.deposit_method === 2) {
        alert('支払方法が現金です、MGRに確認してください。')
        document.activeElement.blur()
      } else {
        return
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.errors {
  color: red;
  font-size: .85rem;
}
.req {
  background: #dffbef;
}
.fa-pencil-square-o {
  margin-right: 5px;
  font-weight: bold;
}
th {
  width: 15%;
}
td {
  width: 35%;
}
td {
  padding: 0 !important;
  height: 34px;
  input {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 34px;
    &.name_w {
      width: 50%;
    }
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  textarea {
    width: 100%;
    font-size: 14px;
    border: none;
    height: 100px;
    &:focus {
      color: #337bc4;
      font-weight: bold;
      border: solid 3px;
      outline: 0;
    }
  }
  .calc {
    padding: 8px;
  }
}
.cancel {
  margin-top: 0 !important;
}
.fa-pencil {
  margin-right: 5px;
  font-weight: bold;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
  border: 1px solid #eee;
}
</style>
<style lang="scss">
.AgreementProfile {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: 14px;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// AgreementProfile.vue?55820346